import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';

import { BrokerService } from '@c4/core';

import { ItemsService } from './../../common/services/items.service';
import { Device } from '../../common/interfaces/item.interface';
import { Binding } from '../../common/interfaces/binding.interface';
import { SharedProgrammingService, CommonProgrammingContext } from './../../common/services/shared-programming.service';
import { ProgrammingUtilsService as Util } from './../../common/services/utils.service';
import { BaseRoutingComponent } from '../../common/base-routing/base-routing.component';

import { QuickstartProgrammingService, QuickstartsContext } from './../services/quickstart-programming.service';
import { QSMediaService, MediaProgrammingContext, Room } from '../quickstart-media/quickstart-media.service';
import { QSThermostatService, ThermostatProgrammingContext } from '../quickstart-thermostats/quickstart-thermostats.service';

const MEDIA_PROXIES = [
  'tuner',
  'tv',
  'control4_network_mediastorage',
  'control4_usb_mediastorage'
];

@Component({
  selector: 'prg-select-action',
  templateUrl: './select-action.component.html',
  styleUrls: ['./select-action.component.less'],
  providers: [
    QSThermostatService
  ]
})
export class SelectActionComponent extends BaseRoutingComponent implements OnInit {

  trigger: Observable<any>;
  supportedActions: Observable<Array<any>>;

  private _mediaDevices: Observable<Device[]>;

  private _stationSupported: Observable<boolean>;
  private _albumSupported: Observable<boolean>;
  private _playlistSupported: Observable<boolean>;
  private _broadcastSupported: Observable<boolean>;
  private _movieSupported: Observable<boolean>;
  private _findRemoteSupported: Observable<boolean>;

  private _mediaActionsSupported: Observable<boolean>;

  private _thermostatSupported: Observable<boolean>;

  constructor(
    protected router: Router,
    protected store: Store<{
      sharedProgramming: CommonProgrammingContext,
      quickstartProgramming: QuickstartsContext,
      mediaProgramming: MediaProgrammingContext,
      thermostatProgramming: ThermostatProgrammingContext
    }>,
    private shared: SharedProgrammingService,
    private utils: Util,
    private route: ActivatedRoute,
    private quickstartService: QuickstartProgrammingService,
    private _mediaService: QSMediaService,
    private _items: ItemsService,
    private _broker: BrokerService
  ) {
    super();

    this._mediaDevices = this._items.itemsList.map(items => {
      return items.filter((item: Device) => {
        return MEDIA_PROXIES.indexOf(item.proxy) > -1;
      });
    });

    this._mediaDevices.subscribe(devices => console.log('media devices: ', devices));

    this._stationSupported = this._mediaDevices.map(ds => ds.some(d => d.proxy === 'tuner'));
    this._broadcastSupported = this._mediaDevices.map(ds => ds.some(d => d.proxy === 'tv'));
    this._albumSupported = this._mediaDevices.map(ds => ds.some(d =>
      ['control4_network_mediastorage', 'control4_usb_mediastorage'].indexOf(d.proxy) > -1
    ));
    this._playlistSupported = this._albumSupported;
    this._movieSupported = this._albumSupported;

    this._findRemoteSupported = this.store.select(s => s.mediaProgramming.remotes)
      .filter(r => !!r)
      .map(r => r.length > 0);

    this._mediaActionsSupported = Observable.combineLatest(
      this._stationSupported,
      this._broadcastSupported,
      this._albumSupported,
      this._playlistSupported,
      this._movieSupported,
      this._findRemoteSupported,
      Util.someTrue
    );

    this._thermostatSupported = this.store.select(s => s.thermostatProgramming)
      .map(c => !!c.thermostats && c.thermostats.length > 0);

    this.supportedActions = this.store.select(s => s.quickstartProgramming.supportedActions);
    this.trigger = this.store.select(s => s.sharedProgramming.trigger.event);
  }

  ngOnInit() {
    this.shared.clearError();
  }

  cancelClicked() {
    this.goToEvent();
    // TODO should this be goHome()?
  }

  private _someRooms = (callback: (room: Room) => boolean): Observable<boolean> => {
    return this.store.select(s => s.mediaProgramming.rooms)
      .filter(r => !!r && r.length > 0)
      .map(rooms => rooms.some(callback))
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/select-action/select-action.component.ts